import dayjs from "dayjs";
import "dayjs/locale/ru";
import "dayjs/locale/en";
import localeRu from "antd/locale/ru_RU";
import localeEn from "antd/locale/en_US";

export const getFormattedLocale = (language: string) => {
  dayjs.locale(language === "ru" ? "ru" : "en");
  dayjs.updateLocale("en", {
    weekStart: 1,
  });

  switch (language) {
    case "ru": {
      return {
        ...localeRu,
        Calendar: { ...localeRu.Calendar, weekStartDay: 1 },
      };
    }
    case "en": {
      return {
        ...localeEn,
        Calendar: { ...localeEn.Calendar, weekStartDay: 1 },
      };
    }
    default: {
      return {
        ...localeEn,
        Calendar: { ...localeEn.Calendar, weekStartDay: 1 },
      };
    }
  }
};
